import { render, staticRenderFns } from "./branchallcountListForApp.vue?vue&type=template&id=507af8ac&scoped=true&"
import script from "./branchallcountListForApp.vue?vue&type=script&lang=js&"
export * from "./branchallcountListForApp.vue?vue&type=script&lang=js&"
import style0 from "./branchallcountListForApp.vue?vue&type=style&index=0&id=507af8ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507af8ac",
  null
  
)

export default component.exports